<script setup>
import {computed, ref} from "vue";
import {useQuery} from "vue-query";
import {useUser} from "../hooks/useUser";
import {currentBrand} from "../queries/brandQueries";

const emit = defineEmits(['select']);
defineProps({
  currentBrand: {
    type: Object,
    required: true
  }
})

const overlay = ref();

const {current: currentUser, swapBrand} = useUser();

const {isLoading: isLoadingUser, data: userData} = useQuery('userCurrent', currentUser);
const {isLoading: isLoadingBrand, data: brandData} = currentBrand();

const user = computed(() => userData.value?.data)
const brand = computed(() => brandData.value?.data)
const userBrands = computed(() => user.value?.brands || []);

const showOtherBrands = (event) => overlay.value ? overlay.value.toggle(event) : false;
const swap = async ({ id }) => {
  await swapBrand(id);
  
  document.location.replace('/');
}

</script>

<template>
  <ProgressSpinner class="small" v-if="isLoadingBrand || isLoadingUser" />
  <div v-else class="swap-brand-container" @click="showOtherBrands">
    <Avatar :image="brand.logo?.url" />
    <div class="swap-brand-name">{{ brand.name }}</div>
    <i v-if="userBrands.length" class="pi pi-angle-down"></i>
  </div>

  <OverlayPanel ref="overlay" v-if="userBrands.length">
    <div v-for="userBrand in userBrands" :key="userBrand.id" class="user-brand-item" @click.prevent="swap(userBrand)">
      <Avatar :image="userBrand.logo?.url"  />
      <div class="swap-brand-name">{{ userBrand.name }}</div>
    </div>
  </OverlayPanel>
</template>

<style lang="scss" scoped>
@import "../assets/sass/theme_variables";

.swap-brand-container {
  display: flex;
  padding: toRem(4) toRem(10) toRem(4) toRem(4);
  background: $shade100;
  border-radius: $borderRadius;
  font-size: toRem(14);
  align-items: center;
  cursor: pointer;

  .p-avatar-circle {
    margin-right: toRem(8);
    img {
      border-radius: $borderRadius;
    }
  }

  .swap-brand-name {
    margin-right: 10px;
  }
}

.user-brand-item {
  display: flex;
  align-items: center;
  cursor: pointer;

  & + & {
    margin-top: 0.5rem;
  }
}

::v-deep(.p-avatar) {
  margin-right: toRem(8);

  &.p-avatar-circle {
    &, img {
      border-radius: $borderRadius;
    }
  }
}

</style>
